import HomePage from "./home_page";

function App() {
  return <HomePage />;
}

export default App;
